import { useState } from "react";
import { Grid, Typography, Box, TextField, useTheme } from "@mui/material";
import styled from "styled-components";

const GlimmerButton = styled.div`
  && {
    font-weight: bold;
    font-size: 18px;

    height: 66%;
    max-width: 300px;
    width: 66%;
    margin: auto;
    cursor: pointer;

    display: block;
    position: relative;
    color: white;
    // border: 1px solid ${(p) => p.theme.palette.primary.main};
    // background-color: #b3890c;
    background-color: rgb(50, 50, 50);
    border-radius: 30px;

    box-shadow: 0 0 0 0 transparent;
    transition: 0.2s ease-in;
    overflow: hidden;

    text-align: center !important;
    padding: 20px;
    cursor: pointer;

    &:active {
      box-shadow: 0 0 0 0 transparent;
      transition: 0.2s ease-out;
    }

    &:before {
      animation: shine 3s 0s infinite;
      content: "";
      display: block;
      width: 0px;
      height: 100%;
      position: absolute;
      top: 0%;
      left: 0%;

      opacity: 0;
      background: white;
      box-shadow: 0 0 30px 3px white;
      transform: skewX(-30deg);
    }

    p {
      margin: auto;
      padding: 10px;
      font-size: 30px;
      text-align: center;
    }
  }
`;

export const EmailCapture = ({ handleSubmit, title }) => {
  const theme = useTheme();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  return (
    <Box
      item
      sx={{
        margin: "auto",
        borderRadius: "10px",
        background: "#db5935",
        p: 2,
        "*": {
          color: "white",
        },
        //         boxShadow: `2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
        // 6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
        // 12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
        // 22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
        // 41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
        // 100px 100px 80px rgba(0, 0, 0, 0.07)`,
      }}
    >
      {title && (
        <Typography textAlign={"center"} variant="h4">
          {title}
        </Typography>
      )}
      <Typography p={2}>
        Leave your email address to have this report, along with a personalised
        action plan to improve your score, sent directly to you.
      </Typography>
      <Box
        sx={{
          width: "100%",
          p: 2,
        }}
      >
        <TextField
          fullWidth
          label="First name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{
            "*": {
              color: "white !important",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          p: 2,
        }}
      >
        <TextField
          fullWidth
          label="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            "*": {
              color: "white !important",
            },
          }}
        />
      </Box>
      <Box>
        <GlimmerButton onClick={() => handleSubmit(name, email)} theme={theme}>
          Send me my report
        </GlimmerButton>
      </Box>
    </Box>
  );
};
